import styled, { css } from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Icon from '../Icon'

export const Container = styled.nav`
  position: fixed;
  inset-block-start: var(--g_height__header);
  inset-block-end: var(--g_height__bottom);
  inset-inline-end: 0;
  z-index: ${({ theme }) => theme.zIndexes.modal};
  width: 100%;
  max-width: min(${pxToRem(480)}, 100svw);
  padding-block: ${pxToRem(32)};
  padding-inline: ${pxToRem(16)};
  overflow: auto;
  scrollbar-width: thin;
  background: ${({ theme }) => theme.colors.white};
  /* background: red; */
  transform: scaleY(1);
  transform-origin: center 0;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0s 0s;
  color: ${({ theme }) => theme.colors.black};
  &[hidden] {
    display: block;
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    transform: scaleY(0.75);
    transform-origin: start center;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
      visibility 0s 1s;
  }
  @media ${mq(sizes.desktop)} {
    inset-block-end: auto;
    padding-inline: ${pxToRem(32)};
    max-height: calc(100svh - var(--g_height__header));
    @supports not (height: 100svh) {
      max-height: calc(100vh - var(--g_height__header));
    }
  }
  @media ${mq(sizes.big)} {
    inset-block-start: var(--g_height__header);
    max-height: calc(100svh - var(--g_height__header));
    @supports not (height: 100svh) {
      max-height: calc(100vh - var(--g_height__header));
    }
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  width: 100%;
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
  }
`
export const Section = styled.div`
  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.greyAA};
    padding-top: ${pxToRem(40)};
  }
`
export const List = styled.ul`
  list-style: none;
  & li {
    position: relative;
  }
`
export const Sub = styled.div`
  --padding-block: ${pxToRem(16)};
  max-height: calc(var(--height__sub, 25vh) + var(--padding-block) * 2);
  transition: max-height 0.2s ease-in-out, padding-block 0.2s ease-in-out;
  padding-block: var(--padding-block);
  &[hidden] {
    display: block;
    max-height: 0;
    visibility: hidden;
    padding-block: 0;
  }
  & ul {
    list-style: none;
    display: flex;
    flex-flow: column;
    gap: ${pxToRem(16)};
    padding-inline-start: ${pxToRem(16)};
    border-inline-start: 1px solid rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease-in-out 0.2s;
  }
  &[hidden] ul {
    opacity: 0;
    transition: opacity 0.2s ease-in-out 0s;
  }
`
export const Item = styled.span`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`
const linkStyles = css`
  ${({ theme }) => theme.textStyles.d1440_button}
  flex: 1;
  display: flex;
  align-items: center;
  min-height: ${pxToRem(40)};
  color: inherit;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h4};
  }
`
export const _Link = styled(Link)`
  ${linkStyles}
`
export const LinkToggle = styled.button`
  ${linkStyles}
  width: 100%;
  background: unset;
`
// 🗣️ label is animated to prevent the toggle icon from moving if animating the item
export const Label = styled.span`
  transition: transform 0.3s ease-in-out;
  li[data-open='true'] &,
  button[aria-expanded='true'] &,
  *:is(button):hover > &,
  *:is(a):hover > & {
    transform: translateX(${pxToRem(8)});
  }
`
export const SubLink = styled(Link)`
  ${({ theme }) => theme.textStyles.m375_body}
  color: inherit;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: translateX(${pxToRem(8)});
    text-decoration: underline;
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body};
  }
`
export const Chevron = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
  transition: transform 0.15s ease-in-out;
  margin-inline-start: auto;
  [aria-expanded='true'] & {
    transform: rotate(180deg);
  }
`
export const Toggle = styled.button<{ $fullWidth?: boolean }>`
  flex: 0 0 auto;
  background: unset;
  color: ${({ theme }) => theme.colors.black};
`
